import React, { Component } from "react";
import axios from "axios";

class Signup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitting: false,
      submitted: false,
      firstName: "",
      email: ""
    };
  }

  handleSubmit = ev => {
    ev.preventDefault();
    this.setState({ submitting: true });
    axios.post(`https://api.convertkit.com/v3/forms/${1102166}/subscribe`, {
      "api_key": "Jpu2ei0PHMixHgu9XuXugA",
      "first_name": this.state.firstName,
      "email": this.state.email
    }).then(() => {
      this.setState({ submitted: true })
    })
  };

  render() {
    return (
      <div className={"signup"}>
        <h2 style={{ marginTop: 0 }}>
          Sign up for the newsletter for TPT Sellers
        </h2>
        <figure
          style={{
            float: "right",
            margin: 10,
            display: "block",
            width: 220,
            textAlign: "center",
            boxShadow: "2px 2px 2px whitesmoke",
            borderRadius: 4,
            padding: 5
          }}
        >
          <img src="/cover1.png" width="160" style={{ margin: "0 auto" }} />
          <figcaption>
            One of the covers you will be designing in the guide
          </figcaption>
        </figure>
        <p>
          When you subscribe you will also get a free step-by-step guide that
          will teach you how to create product covers that sell:
          <ul>
            <li>
              5 easy starter layouts that you can tweak and remix to make unique
              and your own
            </li>
            <li>Tips for choosing fonts that work well together</li>
            <li>
              The simplest way to create contrast (aka stand out!) with color
            </li>
          </ul>
        </p>
        {this.state.submitted && (
          <div style={{ width: '100%', fontWeight: 500, textAlign: 'center', fontSize: '1.1em' }}>
           Success. Check your e-mail to confirm your subscription.
          </div>
        )}
        {!this.state.submitted && (
          <div id="mc_embed_signup" style={{ width: "100%" }}>
            <form
              onSubmit={this.handleSubmit}
              method="post"
              id="mc-embedded-subscribe-form"
              name="mc-embedded-subscribe-form"
              className="validate"
              target="_blank"
            >
              <div className={"signupInner"}>
                <input
                  type="text"
                  value={this.state.firstName}
                  onChange={ev => this.setState({ firstName: ev.target.value })}
                  placeholder="First Name"
                  required
                  name="FNAME"
                  className=""
                  aria-label="First Name"
                  id="mce-FNAME"
                />
                <input
                  type="email"
                  value={this.state.email}
                  onChange={ev => this.setState({ email: ev.target.value })}
                  placeholder="E-mail address"
                  required
                  aria-label="E-mail address"
                  name="EMAIL"
                  className="required email"
                  id="mce-EMAIL"
                />
                <div id="mce-responses" className="clear">
                  <div
                    className="response"
                    id="mce-error-response"
                    style={{ display: "none" }}
                  />
                  <div
                    className="response"
                    id="mce-success-response"
                    style={{ display: "none" }}
                  />
                </div>
                <div
                  style={{ position: "absolute", left: "-5000px" }}
                  aria-hidden="true"
                >
                  <input
                    type="text"
                    name="b_42d2189637b5744c75f13151e_d5bc3a53d2"
                    tabIndex="-1"
                    defaultValue=""
                  />
                </div>
                <div className="clear">
                  <input
                    type="submit"
                    value={this.state.submitting ? "Submitting" : "Subscribe"}
                    name="subscribe"
                    id="mc-embedded-subscribe"
                    className="button"
                    disabled={this.state.submitting}
                  />
                </div>
              </div>
            </form>
          </div>
        )}
      </div>
    );
  }
}

export default Signup;
